import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export const SectionSkeleton = () => {
  return (
    <Card className="mb-8 pt-1 h-[590px] md:h-[776px]">
      <CardHeader className="flex flex-row items-center justify-between pb-4">
        <div className="flex items-center gap-3 flex-1">
          <Skeleton className="h-6 w-6" />
          <Skeleton className="h-8 w-48" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-9 w-9" />
          <Skeleton className="h-9 w-9" />
          <Skeleton className="h-9 w-9" />
        </div>
      </CardHeader>
      <CardContent>
        {/* Countdown Banner Skeleton */}
        <div className="mb-4">
          <Skeleton className="h-24 w-full" />
        </div>
        
        {/* Phase Carousel Skeleton - Horizontal scroll on all screen sizes */}
        <div>
          {/* Match actual horizontal scroll structure on all breakpoints */}
          <div className="w-full max-w-[calc(100vw-1rem)] mx-auto px-1 md:max-w-[calc(100vw-1.5rem)] md:px-2 lg:max-w-[calc(100vw-2rem)] lg:px-2">
            <div className="overflow-x-auto overflow-y-hidden pb-4">
              <div className="flex gap-4 min-w-max pl-0 pr-8 pt-4">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="flex-shrink-0 w-[180px] md:w-[280px] lg:w-[360px]">
                    <Skeleton className="h-[210px] md:h-[320px] lg:h-[420px] w-full" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
